<!--
 * @Author: 李昊
 * @Date: 2020-05-21 17:51:33
 * @LastEditors: 李昊
 * @LastEditTime: 2020-05-24 21:23:11
 * @Description:
-->
<script>
const farmId = 1;
const companyId=65;
const landSn = 'LD00010006';
const cropName = '';
const landList = [];
const landSnList = [ 'LD00010001' ,'LD00010002',  'LD00010003', 'LD00010004', 'LD00010005','LD00010006', 'LD00010007', 'LD00010008', 'LD00010009', 'LD00010010', 'LD00010011','LD00010012','LD00010015'];
const farmapiurl = 'http://60.210.100.74:8097/';
const omsportalapiurl = 'http://60.205.246.102:8081/';
const newFarmapiUrl='http://qijiapi.lzqccy.cn/';
export default {
    farmId, //园区id
    companyId,//公司id
    landSn, // 地块id
    cropName, //地块下种植的作物名称
    landList, // 园区下的地块列表
    landSnList, //园区下的地块sn列表
    farmapiurl, // 园区业务系统接口前缀
    omsportalapiurl, // 运营中心业务系统接口前缀
    newFarmapiUrl,//园区业务接口
}
</script>



// WEBPACK FOOTER //
// src/components/Global.vue